import BaseModel from "./BaseModels/BaseModel"

export enum OrganisationContactLabel {
  CEO = "CEO",
  SECURITY_MANAGER = "SECURITY_MANAGER",
  ORGANISATIONAL_MANAGER = "ORGANISATIONAL_MANAGER",
  FINANCIAL_MANAGER = "FINANCIAL_MANAGER",
  SERVICE_DESK = "SERVICE_DESK"
}

export class OrganisationContact extends BaseModel {
  name = ""
  phone = ""
  email = ""
  label?: OrganisationContactLabel

  constructor(label: OrganisationContactLabel) {
    super();
    this.label = label;
  }
}


